import { TableFieldModel } from '@/model/TableList'
import { numberTimes, priceWithoutRate, totalPriceWithoutRate } from '@/utils/index'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'fee',
    fieldName: '外包费用',
    isMoney: true,
    textAlign: 'right',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'rate',
    fieldName: '外包费用税率'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'containsRate',
    fieldName: '是否含税',
    formatType: 'boolean',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'outsourceCompany',
    fieldName: '外包商'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'accountAlias',
    fieldName: '外包商账户'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'status',
    fieldName: '状态',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'times',
    fieldName: '申请次数',
    width: 130
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'customerCompany',
    fieldName: '公司名称'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'ticketCompany',
    fieldName: '所属公司'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessNo',
    fieldName: '业务编号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessBrand',
    fieldName: '业务品牌'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessName',
    fieldName: '业务名称'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessModel',
    fieldName: '型号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessSerial',
    fieldName: '序列号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'customerOrderNo',
    fieldName: '订单号码'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessUnit',
    fieldName: '单位',
    width: 60
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessAmount',
    fieldName: '数量',
    width: 80
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderTaxRate',
    fieldName: '订单税率',
    width: 80,
    convert: context => {
      const { rowData } = context
      const { orderTaxRate } = rowData.business
      if (!orderTaxRate) {
        return ''
      }
      return orderTaxRate + '%'
    }
  },
  // 业务订单税费
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee2',
    fieldName: '单价(未税)',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const { orderFee } = rowData.business
      if (!orderFee) {
        return ''
      }
      const { orderTaxRate } = rowData.business
      return priceWithoutRate(orderFee, true, orderTaxRate)
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee',
    fieldName: '单价(含税)',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const { orderFee } = rowData.business
      if (!orderFee) {
        return ''
      }
      return orderFee
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee3',
    fieldName: '总价(未税)',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const { orderFee, orderTaxRate } = rowData.business
      if (!orderFee) {
        return ''
      }
      const { businessAmount } = rowData
      return totalPriceWithoutRate(orderFee, businessAmount, true, orderTaxRate)
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee4',
    fieldName: '总价(含税)',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const { orderFee } = rowData.business
      if (!orderFee) {
        return ''
      }
      const { businessAmount } = rowData
      return numberTimes(orderFee, businessAmount, true)
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'salesManName',
    fieldName: '业务代表',
    width: 100,
    convert: context => {
      const { rowData } = context
      const { salesMan } = rowData.business
      return salesMan
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'invoiceStatus',
    fieldName: '开票状态',
    width: 100,
    formatter: (rowData: any) => (rowData.status === 0 ? '已退票作废' : '正常')
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'invoiceType',
    fieldName: '发票类型',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'receivedStatus',
    fieldName: '收款状态',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'updateTime',
    fieldName: '申请时间',
    width: 160,
    convert: ({ rowData }) => rowData.updateTime || rowData.createTime || ''
  }
]
